import { render } from "./currency-icon.vue?vue&type=template&id=80535d84"
import script from "./currency-icon.vue?vue&type=script&lang=js"
export * from "./currency-icon.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__